<template>
  <transition name="fade-transition" mode="out-in">
    <div v-show="isSelected" :class="[[className], { [activeClassName]: isSelected }]" v-bind="$attrs" ref="content" tabindex="-1">
      <slot v-if="isActive" />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TabContent',

  props: {
    className: {
      type: String,
      default: 'c-tabs__content'
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isLazy: {
      type: Boolean,
      default: false
    }
  },

  mounted () {
    this.$watch(() => this.isSelected, isSelected => {
      this.$nextTick(() => isSelected && this.$refs.content.focus({ preventScroll: true }))
    })
  },

  computed: {
    isActive () {
      return this.isLazy ? this.isSelected : true
    }
  },

  inject: ['activeClassName']
}
</script>
